import { useEffect, useState } from 'react';
import { View } from 'react-native';

import { Button, COLORS, Text } from '../Basics';
import { useStore } from '../../store/Context';

/**
 * Painéis laterais do Supervisor (atendimentos / perdas) — Fase 3 embed.
 */
export const SupervisorPanels = () => {
  const { lorentz = {} } = useStore();
  const panels = lorentz.supervisorPanels || {};
  const [active, setActive] = useState(null);

  const items = [
    { key: 'atendimentos', label: 'Atendimentos', url: panels.atendimentos },
    { key: 'perdas', label: 'Perdas', url: panels.perdas }
  ].filter(item => item.url);

  useEffect(() => {
    const onOpen = ev => {
      const panel = ev.detail?.panel;
      if (panel && items.some(i => i.key === panel)) {
        setActive(panel);
      }
    };

    document.addEventListener('lorentz:supervisor:open-panel', onOpen);
    return () =>
      document.removeEventListener('lorentz:supervisor:open-panel', onOpen);
  }, [items.length]);

  if (!lorentz.supervisorEmbed || items.length === 0) return null;

  const current = items.find(i => i.key === active);

  return (
    <View style={{ marginTop: 8 }}>
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6 }}>
        {items.map(item => (
          <Button
            key={item.key}
            color={active === item.key ? 'primary' : 'secondary'}
            onClick={() => setActive(active === item.key ? null : item.key)}
            style={{ paddingHorizontal: 10, paddingVertical: 6 }}
          >
            <Text
              style={{
                color: active === item.key ? '#fff' : COLORS.text,
                fontSize: 12
              }}
            >
              {item.label}
            </Text>
          </Button>
        ))}
      </View>

      {current?.url ? (
        <div
          style={{
            marginTop: 8,
            border: `1px solid ${COLORS.borderColor}`,
            borderRadius: 6,
            overflow: 'hidden',
            height: 220
          }}
        >
          <iframe
            title={current.label}
            src={current.url}
            style={{ width: '100%', height: '100%', border: 0 }}
          />
        </div>
      ) : null}
    </View>
  );
};

export default SupervisorPanels;
